<template>
  <div class="policy max-w-full">
    <p>リアルタイム経路検索</p>
    <ul class="flex">
      <li class="link-text"><a class="break-all" href="https://transit.jre-maas.com/terms" target="_blank"> ・利用規約</a></li>
      <li class="link-text"><a href="https://transit.jre-maas.com/privacy" class="break-all" target="_blank">・プライバシーポリシー</a></li>
    </ul>
    <p>にいがたチョイnavi</p>
    <div class="break-all link-text" href="https://niigata-choinavi.com/docs/policy.html" @click="openCookieUrl">・Cookieポリシー</div>
  </div>
</template>

<script>

export default {
  methods: {
    openCookieUrl: function () {
      this.$router.push( {name: 'cookiepolicy' })
    }
  }
}
</script>

<style lang="scss" scoped>
.policy {
  background-color: #fff;
  margin-top: 6px;
  padding:6px 12px;
  width: 100%;
}
.small_msg{
  font-size: 0.5rem !important
}
.link-text{
  display: inline-block;
  margin-left: 20px;
}
@media (min-height: 800px) {
  .policy{
    bottom: 3rem;
    position: fixed;
  }
}
</style>
